import React from 'react';
import { number, object } from 'prop-types';
import classNames from 'classnames';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';
import { getBuyerTooltip } from '../../../utils/translation/pricingFactors/buyerTooltip';
import { BUYER_REQUESTED_COUNT } from '../../../utils/pricingFactors';

import CalculatorInput from './CalculatorInput';

import './style.scss';

const PackageCalculator = (
    { id, price, name, currentValue, value, additionalValue, packageId },
    { currencyConverter, general: { subCategoryId } }
) => {
    const getCalculatorBuyerTooltip = (i18n) => getBuyerTooltip(i18n, name, subCategoryId)
        .replace('%{includedAmount}', value)
        .replace('%{additionalAmountStep}', additionalValue)
        .replace('%{additionalPriceStep}', currencyConverter.convert(price));

    const formInputName = `calculators[${id}][quantity]`;

    return (
        <I18nProvider>
            {({ i18n }) => (
                <div className={classNames('package-calculator', 'hint--top')}
                    data-hint={getCalculatorBuyerTooltip(i18n)}>
                    <CalculatorInput packageId={packageId}
                        initValue={value}
                        currentValue={currentValue}
                        id={id}/>
                    {/* todo: remove BUYER_REQUESTED_COUNT field after BE adjustment */}
                    <input type="hidden" name={BUYER_REQUESTED_COUNT} value={currentValue}/>
                    <input type="hidden" name={formInputName} value={currentValue}/>
                </div>
            )}
        </I18nProvider>
    );
};

PackageCalculator.propTypes = {
    id: number,
    price: number,
    name: number,
    currentValue: number,
    value: number,
    additionalValue: number,
    packageId: number
}.isRequired;

PackageCalculator.contextTypes = {
    currencyConverter: object,
    general: object
};

export default PackageCalculator;
